// extracted by mini-css-extract-plugin
export default {"sectionTitle":"SectionTitle_sectionTitle__1M-ph","sectionTitle2":"SectionTitle_sectionTitle2__Rr9mI"};